export const navLinks = [
    { title: "Plans", link: "/plans" },
    { title: "What we offer", link: "/home/what-we-offer" },
    { title: "Testimonials", link: "/home/testimonials" },
    { title: "How we work", link: "/home/how-we-work" },
    { title: "FAQ", link: "/faq" },
    { title: "Skills", link: "/home/skills" },
];